export default __webpack_public_path__ + "static/media/Chestplate of the Beyond.010676d9.jpg";